var _path, _line;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWalletLogin = function SvgWalletLogin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    className: "ml-1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 7.875H27.75C27.75 7.46079 27.4142 7.125 27 7.125V7.875ZM27 14.125V14.875C27.4142 14.875 27.75 14.5392 27.75 14.125H27ZM20.5 10.25C20.0858 10.25 19.75 10.5858 19.75 11C19.75 11.4142 20.0858 11.75 20.5 11.75V10.25ZM20.513 11.75C20.9272 11.75 21.263 11.4142 21.263 11C21.263 10.5858 20.9272 10.25 20.513 10.25V11.75ZM3.60003 1.75H24.4V0.25H3.60003V1.75ZM26.25 3.5V18.5H27.75V3.5H26.25ZM24.4 20.25H3.60003V21.75H24.4V20.25ZM1.75003 18.5V3.5H0.250031V18.5H1.75003ZM3.60003 20.25C2.55031 20.25 1.75003 19.439 1.75003 18.5H0.250031C0.250031 20.3224 1.77787 21.75 3.60003 21.75V20.25ZM26.25 18.5C26.25 19.439 25.4498 20.25 24.4 20.25V21.75C26.2222 21.75 27.75 20.3224 27.75 18.5H26.25ZM24.4 1.75C25.4498 1.75 26.25 2.56095 26.25 3.5H27.75C27.75 1.67762 26.2222 0.25 24.4 0.25V1.75ZM3.60003 0.25C1.77787 0.25 0.250031 1.67762 0.250031 3.5H1.75003C1.75003 2.56095 2.55031 1.75 3.60003 1.75V0.25ZM19.85 8.625H27V7.125H19.85V8.625ZM26.25 7.875V14.125H27.75V7.875H26.25ZM27 13.375H19.85V14.875H27V13.375ZM19.85 13.375C18.4413 13.375 17.35 12.2842 17.35 11H15.85C15.85 13.1676 17.6689 14.875 19.85 14.875V13.375ZM19.85 7.125C17.6689 7.125 15.85 8.83244 15.85 11H17.35C17.35 9.71578 18.4413 8.625 19.85 8.625V7.125ZM20.5 11.75H20.513V10.25H20.5V11.75Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 2.5,
    x2: 7,
    y2: 20,
    stroke: "white",
    strokeDasharray: "1 1"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWalletLogin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/WalletLogin.f959665d.svg";
export { ForwardRef as ReactComponent };